import {
  ButtonStatesInterface,
  PropertyDocumentViewListItem,
} from "./PropertyDocumentViewListItem";

interface PDDocumentsListProps {
  propertyDocuments: any[];
  propertyData: any;
  onDocumentView: (doc: any) => void;
  viewDocumentButtonStates?: ButtonStatesInterface;
}

export const PDDocumentsList: React.FC<PDDocumentsListProps> = ({
  propertyDocuments = [],
  propertyData = {},
  onDocumentView = (_doc: any) => {},
  viewDocumentButtonStates = {
    processing: false,
    success: false,
    error: false,
  },
}) => {
  return (
    <>
      {propertyDocuments?.map((document: any, index: number) => (
        <PropertyDocumentViewListItem
          key={`${document?.id}-${propertyData?.listing_id}-document-${index}`}
          documentTitle={document?.title}
          viewDocumentButtonStates={viewDocumentButtonStates}
          onViewDocument={(document) => {
            onDocumentView(document);
          }}
          document={document}
        />
      ))}
    </>
  );
};
